import React, { useEffect, useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import 'rsuite/dist/rsuite-no-reset.min.css';

import { API_BASE_URL } from "./baseURL";
import DatePicker from "rsuite/DatePicker";
import moment from "moment/moment";

const Calender = () => {
    const date = new Date();

    const [year, setYear] = useState(date.toLocaleString('de-DE', {year: 'numeric'}));
    const [month, setMonth] = useState(date.toLocaleString('de-DE', {month: 'long'}));
    const [notes, setNotes] = useState(null);
    const [users, setUsers] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState('');

    useEffect(() => {
        if (!users) {
            fetch(`${API_BASE_URL}/users/salespersons`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem('token')
                },
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => setUsers(data));
        }

    }, []);

    const handleChangeYear = (event) => {
        setYear(event.target.value)
    };

    const handleChangeMonth = (event) => {
        setMonth(event.target.value)
    }

    function fetchNotesForMonth() {
        fetch(`${API_BASE_URL}/farmers/notes-monthly/${year}/${month}`, {
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            method: "POST",
        })
            .then((response) => response.json())
            .then((data) => setNotes(data));

        setSelectedPeriod(`Monat ${month}, ${year}`);
    }

    function fetchNotesForWeek() {
        const dateFrom = objWeek.dateFrom.toISOString().split('T')[0]
        const dateTo = objWeek.dateTo.toISOString().split('T')[0]


        fetch(`${API_BASE_URL}/farmers/notes-weekly/${dateFrom}/${dateTo}`, {
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            method: "POST",
        })
            .then((response) => response.json())
            .then((data) => setNotes(data));

        let weekNumber = moment(objWeek.dateFrom).isoWeek();
        let year = moment(objWeek.dateFrom).year();
        setSelectedPeriod(`KW ${weekNumber}, ${year}`);
    }

    const handleSelectAD = (event) => {
        let user = event.target.value.toLowerCase();

        notes.forEach(note => note.isHidden = false);

        if(user === 'alle') {
            setNotes(notes.map(note => {return note}));
        } else {
            const filteredData = notes.map(note => {
                if(note.user !== user) {
                    note.isHidden = true;
                }
                return note;
            })
            setNotes(filteredData);
        }
    };

    const [objWeek, setObjWeek] = useState({
        date: null,
        dateFrom: null,
        dateTo: null,
        weekNumber: null
    });

    const onChange = (date) => {
        const weekNumber = moment(date).isoWeek();
        const dateFrom = moment(date).startOf('isoWeek').toDate();
        const dateTo = moment(date).endOf('isoWeek').toDate();
        setObjWeek({
            date,
            dateFrom,
            dateTo,
            weekNumber
        })
    }

    const renderValue = (date) => {
        const weekNumber = moment(date).isoWeek();
        const year = moment(date).year();
        return `W${weekNumber}, ${year}`;
    }

    return (
        <>
            <FormControl sx={{ width: 100 }} style={{marginLeft: "20px", marginTop: "20px"}}>
                <InputLabel id="demo-simple-select-label"> Jahr </InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={year}
                    label="Age"
                    onChange={handleChangeYear}
                    variant="outlined">
                        <MenuItem value="2025" > 2025 </MenuItem>
                        <MenuItem value="2026" > 2026 </MenuItem>
                </Select>
            </FormControl>

            <FormControl sx={{ width: 200 }} style={{marginLeft: "20px", marginTop: "20px"}}>
                <InputLabel id="demo-simple-select-label"> Monat </InputLabel>
                <Select
                    labelId="demo-simple-select-label11"
                    id="demo-simple-select11"
                    value={month}
                    label="month"
                    onChange={ handleChangeMonth }
                    variant="outlined">
                        <MenuItem value="Januar"> Januar </MenuItem>
                        <MenuItem value="Februar"> Februar </MenuItem>
                        <MenuItem value="März"> März </MenuItem>
                        <MenuItem value="April"> April </MenuItem>
                        <MenuItem value="Mai"> Mai </MenuItem>
                        <MenuItem value="Juni"> Juni </MenuItem>
                        <MenuItem value="Juli"> Juli </MenuItem>
                        <MenuItem value="August"> August </MenuItem>
                        <MenuItem value="September"> September </MenuItem>
                        <MenuItem value="Oktober"> Oktober </MenuItem>
                        <MenuItem value="November"> November </MenuItem>
                        <MenuItem value="Dezember"> Dezember </MenuItem>
                </Select>
            </FormControl>

            <button
                type="text"
                className="mb-4 p-2 border border-gray-300 rounded"
                onClick={()=> fetchNotesForMonth()}
                style={{ backgroundColor: "green", color: "white", marginLeft: "20px", marginTop: "20px" }}> Notizen holen </button>

            <text style={{ marginLeft: "20px", marginRight: "20px" }}> Oder nach KW </text>

            <DatePicker style={{marginLeft: "20px"}}
                placeholder='Week picker'
                isoWeek
                showWeekNumbers
                value={objWeek.date}
                onChange={onChange}
                renderValue={renderValue}
            />

            <button
                type="text"
                className="mb-4 p-2 border border-gray-300 rounded"
                onClick={()=> fetchNotesForWeek()}
                style={{ backgroundColor: "green", color: "white", marginLeft: "20px", marginTop: "20px" }}> Notizen holen </button>

            <FormControl sx={{ width: 250, marginLeft: "100px", marginTop: "20px" }}>
                <InputLabel>AD wählen</InputLabel>
                <Select
                    id="user"
                    onChange={ handleSelectAD }
                    variant="outlined">
                    <MenuItem value="alle">Alle</MenuItem>
                        { users ?
                            users.map((user) => {
                                return (
                                    <MenuItem key={user.id} value={user.surname}>{user.surname}</MenuItem>
                                );
                            }): null }
                </Select>
            </FormControl>

            { notes ? (
                <div style={{ margin: "20px 20px 20px 20px" }}>
                    <text style={{ marginRight: "20px", color: "red" }}> { selectedPeriod } </text>
                    <table>
                        <thead>
                            <tr>
                                <th style={{width:"10%", paddingLeft: "10px"}}>Datum</th>
                                <th style={{width:"10%"}}>AD</th>
                                <th style={{width:"25%"}}>Landwirt</th>
                                <th style={{width:"65%"}}>Notiz</th>
                            </tr>
                        </thead>
                        <tbody>
                            { notes.map((note, index) => note.isHidden ? null :(
                                <tr key={index} id="rowId" value={ note.id }>
                                    <td style={{padding: "10px"}}>{ new Date(note.date).toLocaleDateString('sv-SE') }</td>
                                    <td>{note.user}</td>
                                    <td>{note.farmer}</td>
                                    <td>{note.comment}</td>
                                </tr>
                            )) }
                        </tbody>
                    </table>
                </div>
            ) : null }
        </>
    );
}

export default Calender;
